import { call, delay, put, race, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from 'typesafe-actions';
import type { SagaConfig } from './pipelineTypes';
import { ActionType } from './pipelineTypes';

import { refreshAuthToken } from '../auth/refreshAuthToken';
import { DEFAULT_API_REQUEST_TIMEOUT_MS } from '../constants';
import {
  getAccountPipelinesFailure,
  getAccountPipelinesSuccess,
} from './pipelineActions';

const pipelineSagaCreator = ({ apiBaseurl, getAuthHeader }: SagaConfig) => {
  function* handleGetPipelines(
    action: PayloadAction<
      ActionType.REQUEST_GET_ACCOUNT_PIPELINES,
      { callback?: any }
    >
  ) {
    yield call(refreshAuthToken);
    try {
      const { response, timeout } = yield race({
        response: call(getAccountPipelines),
        timeout: delay(DEFAULT_API_REQUEST_TIMEOUT_MS),
      });

      if (!timeout) {
        yield put(getAccountPipelinesSuccess(response));

        // oxlint-disable-next-line eslint/no-unused-expressions -- FIXME: pre-existing error: Expected expression to be used
        action.payload.callback && action.payload.callback(response);
      }
    } catch (error: any) {
      yield put(getAccountPipelinesFailure(error));
    }
  }

  const getAccountPipelines = async () => {
    const authHeader = await getAuthHeader();

    return fetch(`${apiBaseurl}/api/pipelines`, {
      method: 'GET',
      headers: {
        Authorization: authHeader,
        'Content-Type': 'application/json',
        'X-Simple-Deal': 'true',
      },
    }).then(async (response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(
          `getAccountPipelines failed: ${response.status} ${response.statusText}`
        );
      }
    });
  };

  return function* () {
    yield takeLatest(
      ActionType.REQUEST_GET_ACCOUNT_PIPELINES,
      handleGetPipelines
    );
  };
};

export default pipelineSagaCreator;
